import React from "react";
import App from "../App";

const Dom = () => {
  return <App />;
};

export default Dom;
